export const BT_ATB_VALIDATOR_REPOSITORY = Symbol.for('BT_ATB_VALIDATOR_REPOSITORY');
export const FULFILMENT_DATA = Symbol.for('FULFILMENT_DATA');
export const BIG_TICKET_DELIVERY_METHODS_REGISTRY = Symbol.for('BIG_TICKET_DELIVERY_METHODS_REGISTRY');
